import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { AuthState } from '../state/auth.state';
import { initialAuthState } from '../state/auth.state';
import { LoginSuccessAction, LogoutAction, SetAuthToken, SetAuthTokenData } from '../action/auth.action';

const authReducer = createReducer(
  initialAuthState,

  on(LoginSuccessAction, (state: AuthState) => ({ ...state })),
  on(SetAuthToken, (state: AuthState, { authToken }) => ({ ...state, authenticatedToken: authToken })),
  on(SetAuthTokenData, (state: AuthState, { authTokenData }) => ({ ...state, ...authTokenData })),
  on(LogoutAction, (state: AuthState) => ({ ...initialAuthState })),
);

export function AuthReducer(state: AuthState | undefined, action: Action) {
  return authReducer(state, action);
}
